export default __webpack_public_path__ + "static/media/SimmmpleAvatar.d0619114.png";